// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3houM","file":"styles_file__3HS6n"};